<template>
	<div>
		<CHead :oHead="Head"></CHead>
		<div class="row justify-content-center">
			<div class="col-12 col-md-12 col-lg-12">
				<nav>
					<div class="nav nav-tabs nav-tabs-table" id="nav-tab" role="tablist">
						<a class="nav-item nav-link active" style="width:12%" id="interno-tab-refaccion" data-toggle="tab" href="#nav-interno-refaccion" role="tab" aria-controls="nav-interno-refaccion" aria-selected="true">Almacén Interno</a>
						<a v-for="(item,index) in ListaDistribuidor" :key="index" @click="CambiarDistro(index)" class="nav-item nav-link nav-pink" style="width:12%" :id="item.IdUsuario+'-tab-refaccion'" data-toggle="tab" :href="'#nav-refaccion-'+item.IdUsuario" role="tab" :aria-controls="'nav-refaccion-'+item.IdUsuario" aria-selected="false">Almacén {{item.Usuario}}</a>
					</div>
				</nav>
				<div class="tab-content tab-content-table">
					<div class="tab-pane fade show active" id="nav-interno-refaccion" role="tabpanel" aria-labelledby="interno-tab-refaccion">
						<Clist :EmitSeccion="EmitSeccion" :regresar="regresar" :Nombre="NameList" @FiltrarC="Lista" :Filtro="Filtro" :isModal="EsModal" :pShowBtnAdd="btnadd" :ShowHead="false" :pConfigLoad="ConfigLoad" :ShowFilas=false>
							<template slot="Filtros">
								<input type="text" class="form-control mr-2 ml-2 lup" v-model="Filtro.Item" placeholder="Item..." @input="Filtrar">
								<input type="text" class="form-control mr-2 ml-2 lup" v-model="Filtro.Descripcion" placeholder="Descripción..." @input="Filtrar">
								<button v-if="ShowBotons" :disabled="DisableBtnExport" type="button" @click="ExportarExcel" class="btn btn-01 mr-2">
									<i v-show="DisableBtnExport" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
									<i v-show="!DisableBtnExport" class="fa fa-file-excel"></i> Generar Excel
								</button>
								<input v-if="ShowBotons" style="display:none" id="ArchivoHoja" @change="SubirArchivo" type="file" ref="file">
								<label v-if="ShowBotons" for="ArchivoHoja" class="btn btn-primary mr-2 mt-1"><i class="fa fa-file-excel"></i> <span class="ml-1">Importar Excel</span></label>
								<span v-if="ShowBotons">{{Archivo}}</span>
								<button v-if="ShowBotons" :disabled="DisableBtnImport" type="button" @click="ImportarExcel" class="btn btn-pink ml-auto">
									<i v-show="DisableBtnImport" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
									<i v-show="!DisableBtnImport" class="fa fa-file-upload"></i> Subir Archivo
								</button>
							</template>
							<template slot="header">
								<tr>
									<th>SKU</th>
									<th>Ítem</th>
									<th>Marca</th>
									<th>Modelo</th>
									<th>Proveedor</th>
									<th>N° Parte</th>
									<th>Descripción</th>
									<th>Unidad</th>
									<th>Stock</th>
									<th>Costo Unitario</th>
									<!-- <th v-if="!ShowBotons">Fecha Precio</th> -->
									<th class="text-center">Acciones</th>
								</tr>
							</template>
							<template slot="body">
								<tr v-for="(lista,index) in ListaRefaccion" :key="index">
									<td v-b-tooltip.hover.top :title="lista.Sku" width="10%">{{ $limitCharacters(lista.Sku,20) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Item" class="text-nowrap" width="10%">{{$limitCharacters(lista.Item,30) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Marca" class="text-nowrap" width="10%">{{$limitCharacters(lista.Marca,30) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Modelo" class="text-nowrap" width="10%">{{$limitCharacters(lista.Modelo,30) }}</td>
									<td>{{lista.Proveedor}}</td>
									<td v-b-tooltip.hover.top :title="lista.NumParte" class="text-nowrap" width="10%">{{$limitCharacters(lista.NumParte,30) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Descripcion" class="text-nowrap" width="23%">{{$limitCharacters(lista.Descripcion,50) }}</td>
									<td class="text-nowrap" width="5%">{{lista.Unidad }}</td>
									<td class="text-nowrap" width="5%">{{lista.Stock }}</td>
                		        	<td class="text-nowrap" width="5%">$ {{Number(lista.Valor).toLocaleString('es-MX') }}</td>
									<!-- <td v-if="!ShowBotons"><i class="fa fa-calendar"></i> {{lista.FechaActValor!=null ? $getCleanDate(lista.FechaActValor,false) : 'S/F' }}</td> -->
									<td class="text-center">
										<!-- <Cbtnaccion v-if="ShowBotons" :ShowButtonG="ShowBotons" :pEmitSeccion="EmitSeccion" :isModal="EsModal" :Id="lista.IdRefaccion" :IrA="FormName">
										</Cbtnaccion> -->
										<button type="button" @click="Add_Refaccion(lista,1)" class="btn-icon mr-2" ><i class="fa fa-plus-circle"></i></button>
									</td>
								</tr>
								<CSinRegistros :pContIF="ListaRefaccion.length" :pColspan="9" ></CSinRegistros>
							</template>
						</Clist>
					</div>
					<div v-for="(item,index) in ListaDistribuidor" :key="index" class="tab-pane fade" :id="'nav-refaccion-'+item.IdUsuario" role="tabpanel" :aria-labelledby="item.IdUsuario+'-tab-refaccion'">
						<Clist :EmitSeccion="EmitSeccion" :regresar="regresar" :Nombre="NameList" @FiltrarC="ListaDistro" :Filtro="FiltroDistro" :isModal="EsModal" :pShowBtnAdd="btnadd" :ShowHead="false" :pConfigLoad="ConfigLoad" :ShowFilas=false>
							<template slot="Filtros">
								<input type="text" class="form-control mr-2 ml-2 lup" v-model="FiltroDistro.Item" placeholder="Item..." @input="FiltrarDistro">
								<input type="text" class="form-control mr-2 ml-2 lup" v-model="FiltroDistro.Descripcion" placeholder="Descripción..." @input="FiltrarDistro">
								<button v-if="ShowBotons" :disabled="DisableBtnExport" type="button" @click="ExportarExcel" class="btn btn-01 mr-2">
									<i v-show="DisableBtnExport" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
									<i v-show="!DisableBtnExport" class="fa fa-file-excel"></i> Generar Excel
								</button>
								<input v-if="ShowBotons" style="display:none" id="ArchivoHoja" @change="SubirArchivo" type="file" ref="file">
								<label v-if="ShowBotons" for="ArchivoHoja" class="btn btn-primary mr-2 mt-1"><i class="fa fa-file-excel"></i> <span class="ml-1">Importar Excel</span></label>
								<span v-if="ShowBotons">{{Archivo}}</span>
								<button v-if="ShowBotons" :disabled="DisableBtnImport" type="button" @click="ImportarExcel" class="btn btn-pink ml-auto">
									<i v-show="DisableBtnImport" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
									<i v-show="!DisableBtnImport" class="fa fa-file-upload"></i> Subir Archivo
								</button>
							</template>
							<template slot="header">
								<tr>
									<th>SKU</th>
									<th>Ítem</th>
									<th>Marca</th>
									<th>Modelo</th>
									<th>N° Parte</th>
									<th>Descripción</th>
									<th>Unidad</th>
									<th>Stock</th>
									<th>Costo Unitario</th>
									<!-- <th v-if="!ShowBotons">Fecha Precio</th> -->
									<th class="text-center">Acciones</th>
								</tr>
							</template>
							<template slot="body">
								<tr v-for="(lista,index) in ListaRefaccionDistribuidor" :key="index">
									<td v-b-tooltip.hover.top :title="lista.Sku" width="10%">{{ $limitCharacters(lista.Sku,20) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Item" class="text-nowrap" width="10%">{{$limitCharacters(lista.Item,30) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Marca" class="text-nowrap" width="10%">{{$limitCharacters(lista.Marca,30) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Modelo" class="text-nowrap" width="10%">{{$limitCharacters(lista.Modelo,30) }}</td>
									<td v-b-tooltip.hover.top :title="lista.NumParte" class="text-nowrap" width="10%">{{$limitCharacters(lista.NumParte,30) }}</td>
									<td v-b-tooltip.hover.top :title="lista.Descripcion" class="text-nowrap" width="23%">{{$limitCharacters(lista.Descripcion,50) }}</td>
									<td class="text-nowrap" width="5%">{{lista.Unidad }}</td>
									<td class="text-nowrap" width="5%">{{Camelize(lista.Stock) }}</td>
                		        	<td class="text-nowrap" width="5%">$ {{Number(lista.Valor).toLocaleString('es-MX') }}</td>
									<!-- <td v-if="!ShowBotons"><i class="fa fa-calendar"></i> {{lista.FechaActValor!=null ? $getCleanDate(lista.FechaActValor,false) : 'S/F' }}</td> -->
									<td class="text-center">
										<!-- <Cbtnaccion v-if="ShowBotons" :ShowButtonG="ShowBotons" :pEmitSeccion="EmitSeccion" :isModal="EsModal" :Id="lista.IdRefaccion" :IrA="FormName">
										</Cbtnaccion> -->
										<button type="button" @click="Add_Refaccion(lista,2)" class="btn-icon mr-2" ><i class="fa fa-plus-circle"></i></button>
										<button @click="AbrirDatos(lista.IdRefaccion)" type="button" class="btn-icon mr-2" data-toggle="modal" data-target="#Refacciones" data-backdrop="static" data-keyboard="false"><i class="fa fa-eye"></i></button>
										<button @click="DescargarPdfReal(lista.Archivo)" type="button" class="btn-icon mr-2"><i class="fa fa-file-pdf"></i></button>
									</td>
								</tr>
								<CSinRegistros :pContIF="ListaRefaccionDistribuidor.length" :pColspan="9" ></CSinRegistros>
							</template>
						</Clist>
					</div>
				</div>
			</div>
			<Modal :TipoM="2" :pEmitSeccion="EmitSeccion" :NameModal="'Refacciones'" :size="size" :Nombre="NameForm" :poBtnSave="oBtnSave" >
             	<template slot="Form">
             		<Form :pDisabled="true" :NameList="NameForm"  :poBtnSave="oBtnSave" :IdActivo="0"></Form>
             	</template>
            </Modal>
		</div>
	</div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Form from '@/views/modulos/distribuidor/almacen/refacciones/Form.vue';
import CHead from "@/components/CHead.vue";
import CSinRegistros from "@/components/CSinRegistros";
export default {
	name :'listCotizacionConfRefaccion',
	props:["pTipo"],
	components :{
        Modal,
        Clist,
        Cbtnaccion,
        Form,
        CHead,
		CSinRegistros
    },
	data() {
		return {
			EmitSeccion:'Refacciones',
			FormName:'Refaccion',
			EsModal:true,//indica si es modal o no,
            CloseModal:true,//indica si el modal cierra o de lo contrario asignarle un evento al boton
            size :"modal-xl",
            NameList:"Refacciones",
            NameForm:"Refacción",
            urlApi:"refacciones/get",
            ListaRefaccion:[],
			ListaRefaccionDistribuidor:[],
            ListaDistribuidor:[],
			ListaHeader:[],
			Rutaicono:'',
            regresar:true,
            ShowBotons:true,
            btnadd:true,  ShowAcciones:true,
			Filtro:{
                Nombre:'',
                Placeholder:'SKU..',
                TotalItem:0,
                Pagina:1,
                Entrada:20,
				Item:'',
				Descripcion:''
            },
			FiltroDistro:{
                Nombre:'',
                Placeholder:'SKU..',
                 TotalItem:0,
                Pagina:1,
                Entrada:20,
				Item:'',
				Descripcion:'',
				IdUsuario:''
            },
			oBtnSave:{
				//valores  isModal(true),nombreModal('ModalForm'),tipoModal=1,regresarA(''),disableBtn(false),txtSave('Guardar'),txtCancel('Cerrar');
                isModal:true,
                disableBtn:false,
                toast:0,
				EmitSeccion:'Refacciones',
				nombreModal:'Refacciones',
				ShowSave:false
            },
			Head: {
				ShowHead: true,
				Title: "Refacciones",
				BtnNewShow: true,
				BtnNewName: "Nuevo",
				isreturn: true,
				isModal: true,
				isEmit: true,
				Url: "",
				ObjReturn: "",
				NameReturn: "Regresar",
				isCuentas: false,
				verFiltroCuentas: false,
				EmitSeccion:'Refacciones'
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			DisableBtnExport:false,
			DisableBtnImport:false,
			RefaccionesTodos:[],
			Archivo:null,
			TimeOut:'',
			errorlista:0,
			RutaArchivo:''
		}
	},
	methods: {
		async Lista() {
			this.ConfigLoad.ShowLoader = true;

			await this.$http.get(
				this.urlApi,
				{
					params:{
						Nombre:this.Filtro.Nombre,
						Entrada:this.Filtro.Entrada,
						pag:this.Filtro.Pagina,
						Item:this.Filtro.Item,
						Descripcion:this.Filtro.Descripcion,
						RegEstatus:'A'
					}
				}
			).then( (res) => {
				this.ListaRefaccion =res.data.data.refacciones;
				// this.RefaccionesTodos=res.data.data.todos;
				this.Filtro.Entrada=res.data.data.pagination.PageSize;
				this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			});
		},
		async ListaDistro(){
			this.ConfigLoad.ShowLoader = true;

			await this.$http.get(
				'refaccionesdistribuidor/get',
				{
					params:{
						Nombre:this.FiltroDistro.Nombre,
						Entrada:this.FiltroDistro.Entrada,
						pag:this.FiltroDistro.Pagina,
						Item:this.FiltroDistro.Item,
						IdUsuario:this.FiltroDistro.IdUsuario,
						RegEstatus:'A',
						NomMaterial:this.FiltroDistro.Descripcion,
						Origen:'cotizacion'
					}
				}
			).then((res)=>{
				let FactorDescuento=1;
				let indexdistro=this.ListaDistribuidor.findIndex((value) => value.IdUsuario==this.FiltroDistro.IdUsuario);
				if (indexdistro!=-1) {
					FactorDescuento=this.ListaDistribuidor[indexdistro].FactorDescuentoRefaccion;
				}
				res.data.data.row.forEach((value) => {
					value.Valor*=FactorDescuento;
				});
				this.ListaRefaccionDistribuidor =res.data.data.row;
				this.RutaArchivo=res.data.data.ruta;
				// this.MaterialesTodos=res.data.data.todos;
				this.FiltroDistro.Entrada=res.data.data.pagination.PageSize;
				this.FiltroDistro.TotalItem=res.data.data.pagination.TotalItems;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			})
		},
		Filtrar(){
			clearTimeout(this.TimeOut);
			this.TimeOut=setTimeout(()=>{
				this.Lista();
			},1000);
		},
		FiltrarDistro(){
			clearTimeout(this.TimeOut);
			this.TimeOut=setTimeout(()=>{
				this.ListaDistro();
			},1000);
		},
		Eliminar(Id)
        {

            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {

                    this.$toast.success('Información eliminada');

                     this.$http.delete(
                            'refacciones/' + Id
                        ).then( (res) => {
                                this.Lista();
                        });

                    }
            });
        },
		Change(titulo)
        {
            this.NameForm=titulo;
            var bdn=true;
            if(titulo=='Iconos'){
                bdn=false;
            }
            this.bus.$emit('cambiar_CloseModal',bdn);
        },
		Limpiar(){
            this.bus.$emit('cambiar_CloseModal',true);
        },
		Add_Refaccion(obj,Tipo){
			obj.FactorDescuento=1;
			if (Tipo==2) {
				let indexdistro=this.ListaDistribuidor.findIndex((value) => value.IdUsuario==this.FiltroDistro.IdUsuario);
				if (indexdistro!=-1) {
					obj.FactorDescuento=this.ListaDistribuidor[indexdistro].FactorDescuentoRefaccion;
				}
			}

            this.bus.$emit('Add_Refacciones',obj,Tipo);
            $('#ModalForm4').modal('hide');
        },
		ExportarExcel(){
			let formData=new FormData();
			formData.set('Refacciones',JSON.stringify(this.RefaccionesTodos));
			this.DisableBtnExport=true;
			this.$http.post('refacciones/excel',formData,{
                responseType: 'blob',
            }).then((res)=>{
				let ExcelContent = res.data;
				let file = new Blob([ExcelContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				let fileUrl = URL.createObjectURL(file);
				var a = document.createElement('a');
  				a.href = fileUrl;
  				a.download = 'refaccion';
  				document.body.append(a);
  				a.click();
  				a.remove();
  				URL.revokeObjectURL(fileUrl);
			}).finally(()=>{
				this.DisableBtnExport=false;
			});
		},
		ImportarExcel(){
			// console.log(this.$refs.file.files[0]);
			this.errorlista=0;
			this.DisableBtnImport=true;
			let formData=new FormData();
			formData.append('Archivo',this.$refs.file.files[0]);
			this.$http.post('refacciones/excelimport',formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res)=>{
				this.$toast.success('Las Refacciones se Han Registrado Correctamente');
				// this.$refs.file.files[0]=null;
				this.DisableBtnImport=false;
			}).catch((err)=>{
				this.errorlista=1;
				this.DisableBtnImport=false;
				this.$toast.warning(err.response.data.message);
			}).finally(()=>{
				// this.Archivo='';
				if (this.errorlista==0) {
					this.Lista();	
				}
			})
		},
		SubirArchivo(){
			const image = this.$refs.file.files[0];
			var FileSize = image.size / 1024 / 1024; // in MB
			if (FileSize > 1) {
				this.$toast.info('Solo se puede subir archivos menores a 1 MB');
				const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
			}
			var allowedExtensions = /(\.xlsx|\.XLSX)$/i;
			if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .xlsx');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='';
                return false;
            }
			this.Archivo=image.name;
		},
		async GetDistribuidores(){
			await this.$http.get('sucursalxdistribuidor/client').then((res)=>{
				this.ListaDistribuidor=res.data.data.todos;
			})
		},
		CambiarDistro(index){
			// console.log(index);
			this.ListaRefaccionDistribuidor=[];
			this.FiltroDistro={
                Nombre:'',
                Placeholder:'SKU..',
                 TotalItem:0,
                Pagina:1,
                Entrada:20,
				Item:'',
				Descripcion:'',
				IdUsuario:''
            };
			this.FiltroDistro.IdUsuario=this.ListaDistribuidor[index].IdUsuario;
			// console.log(this.FiltroDistro.IdUsuario);
			this.ListaDistro();
		},
		DescargarPdfReal(nombre)
        {

            let pdfWindow = window.open(this.RutaArchivo+nombre);
            pdfWindow.document.write("<iframe width='100%' height='100%' src='" + this.RutaArchivo+nombre +"'></iframe>");
        },
		AbrirDatos(IdRefaccion){
			this.bus.$emit('NewModal_'+this.EmitSeccion,0,IdRefaccion);
		},
		Camelize(str){
			var splitStr = str.toLowerCase().split(' ');
   			for (var i = 0; i < splitStr.length; i++) {
   			    // You do not need to check if i is larger than splitStr length, as your for does that for you
   			    // Assign it back to the array
   			    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
   			}
   			// Directly return the joined string
   			return splitStr.join(' '); 
		}
	},
	created() {
		this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List_'+this.EmitSeccion);
        this.bus.$off('Limpiar');
         this.bus.$off('Regresar');
        // this.Lista();

        if(this.pTipo!==undefined){
           if(this.pTipo===2){
                this.regresar=false;
                this.ShowBotons=false;
                this.btnadd=false;
				this.Head.ShowHead = false;
                this.bus.$emit('Cambiar_Footer',false);
           }
        }else {
			this.pTipo = 1;
		}

        this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        {
            this.Eliminar(Id);

        });
         this.bus.$on('List_'+this.EmitSeccion,()=>
        {
            this.Lista();
        });

        this.bus.$on('Limpiar',()=>
        {
            this.Limpiar();
        });
         this.bus.$on('Regresar',()=>
        {
            this.$router.push({name:'distribuidoralmacen'});
        });
	},
	mounted() {
        this.Lista();
		this.GetDistribuidores();
    },
}
</script>

<style>

</style>
